
import SearchString from './SearchString';
export default SearchString;    
